module.exports = __webpack_public_path__ + "img/grab-voucher.47c46b90.png";